import { AvailableOptions, StandardResponse } from '@ph-model/response/interface';

export class GetProductsResponse {
  constructor(
    public availableOptions: AvailableOptions,
    public standardResponse: StandardResponse
  ) {}
}
